import React, { useEffect, useRef } from 'react';
import { Modal, Button, Form, FormGroup, Row, Col, Dropdown, DropdownItem, Badge } from 'react-bootstrap';
import { LifePart } from '../../state/LifePart';

interface FilterModalProps {
    show: boolean;
    onHide: () => void;
    filterPart: string;
    setFilterPart: (val: string) => void;
    searchTerm: string;
    setSearchTerm: (val: string) => void;
    hideDone: boolean;
    setHideDone: (val: boolean) => void;
    roles: { objects: Record<string, LifePart> } | undefined;
}

export const FilterModal: React.FC<FilterModalProps> = ({
    show, onHide, filterPart, setFilterPart, searchTerm, setSearchTerm, hideDone, setHideDone, roles
}) => {
    const searchInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (show) {
            setTimeout(() => searchInputRef.current?.focus(), 100);
        }
    }, [show]);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} onKeyDown={handleKeyDown}>
            <Modal.Header closeButton>
                <Modal.Title>Настройки фильтра</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column sm="4">Показывать только</Form.Label>
                        <Col sm="8">
                            <Dropdown onClick={e => e.stopPropagation()}>
                                <Dropdown.Toggle size="sm" variant="outline-secondary" style={{ maxWidth: '100%', textOverflow: "ellipsis", overflow: "hidden" }}>
                                    {Object.values(roles?.objects || {}).find(p => p.uuid === filterPart)?.name || "Все"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item key={`p-all`} onClick={() => setFilterPart("")}>Все</Dropdown.Item>
                                    {Object.values(roles?.objects || {}).sort((a, b) => (a.order || 0) - (b.order || 0)).map(part =>
                                        <DropdownItem
                                            key={`p-${part.uuid}`}
                                            onClick={() => setFilterPart(part.uuid)}
                                        >
                                            <Badge bg="" style={{ backgroundColor: part.color, width: 20, marginRight: 10, display: 'inline-block' }}> </Badge>
                                            {part.name}
                                        </DropdownItem>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </FormGroup>
                    <FormGroup as={Row} className="mb-3">
                        <Form.Label column sm="4">Фильтр карточек</Form.Label>
                        <Col sm="8">
                            <Form.Control ref={searchInputRef} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                        </Col>
                    </FormGroup>
                    <FormGroup as={Row}>
                        <Form.Label column sm="4">Скрывать готовые</Form.Label>
                        <Col sm="8">
                            <Form.Check
                                type="checkbox"
                                checked={hideDone}
                                onChange={e => setHideDone(e.target.checked)}
                            />
                        </Col>
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Закрыть</Button>
            </Modal.Footer>
        </Modal>
    );
};